import React, { useEffect } from "react";
import authStore from "../../stores/authStore";
import { Navigate } from "react-router-dom";
import MyLoader from "../myLoader/MyLoader";

const RequireAuth = (props) => {
  const store = authStore();
  useEffect(() => {
    if (store.loggedIn === null) {
      store.checkAuth();
    }
  }, []);

  if (store.loggedIn === null) {
    return <div><MyLoader height="100vh" /></div>;
  }

  if (store.loggedIn === false) {
    return <Navigate to="/sign-in" />;
  }

  return <div>{props.children}</div>;
};

export default RequireAuth;
